@if (isMenu) {
  <button mat-menu-item [attr.aria-label]="'starred' | translate">
    <mat-icon>star_border</mat-icon>
    {{ 'starred' | translate }}
  </button>
} @else {
  <app-loading-icon-button
    label="starred"
    classMatIcon="{{ iconFull ? 'iconFull' : '' }}"
    icon="{{ iconFull ? 'star' : 'star_border' }}"
    [showButton]="!showLoading"
    [showLoading]="showLoading"></app-loading-icon-button>
}
